import { render, staticRenderFns } from "./licensing-settings.vue?vue&type=template&id=f6438046&"
import script from "./licensing-settings.vue?vue&type=script&lang=js&"
export * from "./licensing-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports